module.exports = __webpack_public_path__ + "a8a10a3e/img/saly-icon.39e12342.jpg";